<template id="zoomable-media-container">
  <div class="outer-container">
    <AuthenticatedMedia
      cssClass="imposed-image"
      :style="styles"
      v-if="media.imposedImage != null && (media.imposedImage.type === 'image' || (media.imposedImage.mime != null && media.imposedImage.mime.includes('image')))"
      :mediaUrl="media.imposedImage.blobURL"
      type="image"
      @update:mediaCapabilities="(value) => propagateEvent('update:mediaCapabilities', value)"></AuthenticatedMedia>
    <AuthenticatedMedia 
      v-if="media.type === 'image' || (media.mime != null && media.mime.includes('image'))"
      :mediaUrl="media.blobURL"
      type="image"
      @update:mediaCapabilities="(value) => propagateEvent('update:mediaCapabilities', value)">
    </AuthenticatedMedia>
    <AuthenticatedMedia 
      v-else-if="media.type === 'video' || (media.mime != null && media.mime.includes('video'))"
      :mediaUrl="media.blobURL"
      controls
      playsinline
      :poster="(media.thumbnail) ? media.thumbnail : undefined"
      :mimeType="media.mime"
      type="video"
      @update:mediaCapabilities="(value) => propagateEvent('update:mediaCapabilities', value)">
    </AuthenticatedMedia>
    <AuthenticatedPDFViewer
      v-else-if="(media.mime != null && media.mime.includes('application/pdf'))"
      :mediaUrl="media.blobURL"
      :mimeType="media.mime"
      @update:mediaCapabilities="(value) => propagateEvent('update:mediaCapabilities', value)"
      :currentPage="currentPage"
      @update:currentPage="(value) => propagateEvent('update:currentPage', value)"
      :zoomValue="zoomValue">
    </AuthenticatedPDFViewer>
    <div v-else class="unsupported-placeholder ">
      <span class="wl-default fl-0">{{ i18n.$t('files.type_not_supported.title') }}</span>
      <span class="wl-light fl-s1">{{ i18n.$t('files.type_not_supported.external_app') }}</span>
    </div>
  </div>
  <!-- TODO Support canvas in the future. Maybe even the PointCanvas -->
</template>

<script>
import { computed, defineComponent } from 'vue';

import AuthenticatedMedia from '@/components/AuthenticatedMedia.vue';
import AuthenticatedPDFViewer from '@/components/AuthenticatedPDFViewer.vue';

import { useI18n } from "@/utils/i18n";

export default defineComponent({
  name: 'ZoomableMediaContainer',
  components: { AuthenticatedMedia, AuthenticatedPDFViewer },
  props: {
    'media': Object,
    'imposedOpacity': {
      type: Number,
      default: 0.6
    },
    'currentPage': {
      type: Number,
      default: 1
    },
    'zoomValue': {
      type: Number,
      default: 1
    }
  },
  emits: [
    'update:mediaCapabilities',
    'update:currentPage'
  ],
  setup(props, { emit }) {
    const i18n = useI18n();

    const styles = computed(() => {
      let style = `opacity: ${props.imposedOpacity};`
      if (props.media != null && props.media.imposedImage != null && props.media.imposedImage.parameters != null) {
        let parameters = props.media.imposedImage.parameters;
        if (parameters.origin != null) style += `object-position: ${parameters.origin};`
      }
      return style;
    });

    const propagateEvent = function(eventName, newvalue) {
      emit(eventName, newvalue);
    }

    return { i18n, styles, propagateEvent }
  },
})
</script>

<style scoped>
.outer-container {
  position: relative;
  margin: 0px;
  padding: 0px;
  border: 0px;
}

.outer-container > *, .outer-container > :deep(*) {
  transform: none!important;
  vertical-align: middle;
}

:deep(video), :deep(img), :deep(canvas) {
  position: relative;
  width: auto;
  height: auto;
  max-height: var(--max-slide-height, 70vh);
  max-width: 100%;
  object-fit: contain;
}

:deep(.imposed-image) {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%!important;
  height: 100%!important;
  max-height: var(--max-slide-height, 70vh);
  max-width: 100%;
  object-fit: contain;
  object-position: center;
}

.unsupported-placeholder {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin: 24px;
  padding: 16px;
  background: var(--ion-background-color);
  border-radius: var(--global-border-radius);
  color: var(--ion-text-color);
}
</style>